var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component } from 'vue-property-decorator';
import { Layout, Dependencies, Auth } from '~/core/decorator';
import NumberRange from "~/components/common/number-range.vue";
import { CaseRepaymentService } from "~/services/domain-service/case-repayment.service";
import { PageService } from '~/utils/page.service';
import { State } from "vuex-class";
import { UserService } from "~/services/management-service/user.service";
import SelectDepartment from "~/components/business-component/select-department.vue";
import { MENU_CHANNEL } from "~/config/enum.config";
var CommissionReport = /** @class */ (function (_super) {
    __extends(CommissionReport, _super);
    function CommissionReport() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.searchModel = {
            deptId: "",
            paymentType: '',
            principalId: '',
            collectorId: '',
            userId: "",
            deptCode: "",
            entryTime: [],
            manualConfirmDate: [],
            overdueAmount: { min: '', max: '' },
            repayAmount: { min: '', max: '' }
        };
        _this.info = {};
        _this.dataSet = [];
        _this.userSet = [];
        return _this;
    }
    CommissionReport.prototype.refreshData = function () {
        var _this = this;
        this.caseRepaymentService.getCommissionReport(this.paramsHandler(), this.pageService)
            .subscribe(function (data) {
            _this.dataSet = data;
        });
    };
    CommissionReport.prototype.getOverdueAmount = function () {
        var _this = this;
        this.caseRepaymentService.getCommissionReportAmount(this.paramsHandler())
            .subscribe(function (data) {
            _this.info = data;
        });
    };
    CommissionReport.prototype.paramsHandler = function () {
        var params = __assign({}, this.searchModel);
        params.manualConfirmDateMin = this.searchModel.manualConfirmDate && this.searchModel.manualConfirmDate.length ? this.$filter.dateTimeFormat(this.searchModel.manualConfirmDate[0]) : '';
        params.manualConfirmDateMax = this.searchModel.manualConfirmDate && this.searchModel.manualConfirmDate.length ? this.$filter.dateTimeFormat(this.searchModel.manualConfirmDate[1]) : '';
        params.entryTimeMin = this.$filter.dateRanageFormat(this.searchModel.entryTime).start;
        params.entryTimeMax = this.$filter.dateRanageFormat(this.searchModel.entryTime).end;
        params.overdueAmountMin = this.searchModel.overdueAmount.min;
        params.overdueAmountMax = this.searchModel.overdueAmount.max;
        params.repayAmountMin = this.searchModel.repayAmount.min;
        params.repayAmountMax = this.searchModel.repayAmount.max;
        delete params.manualConfirmDate;
        delete params.entryTime;
        delete params.overdueAmount;
        delete params.repayAmount;
        return params;
    };
    CommissionReport.prototype.departemntChange = function (id, code) {
        this.searchModel.deptCode = code;
        this.searchModel.userId = '';
        if (!code) {
            this.userSet = [];
        }
        else {
            this.getAllUserByDeptCode(code);
        }
    };
    CommissionReport.prototype.getAllUserByDeptCode = function (deptCode) {
        var _this = this;
        this.userService.getAllUsersList({ deptCode: deptCode }).subscribe(function (data) { return _this.userSet = data; });
    };
    CommissionReport.prototype.created = function () {
        this.refreshData();
        this.getOverdueAmount();
    };
    CommissionReport.prototype.handleResetForm = function () {
        this.searchModel.deptCode = '';
        this.searchModel.overdueAmount = { min: '', max: '' };
        this.searchModel.overdueAmount = { min: '', max: "" };
    };
    CommissionReport.prototype.exportCaseInfo = function () {
        var _this = this;
        if (!this.dataSet.length)
            return this.$message.warning('暂无数据无需导出！');
        this.caseRepaymentService.commissionReportExport(this.paramsHandler())
            .subscribe(function (data) {
            _this.$common.downloadFile(data.url);
        });
    };
    /**
     * 进入查看执行页
     */
    CommissionReport.prototype.openExecutionPage = function (row) {
        this.$router.openCaseDetail(row.id, {
            menuChannel: MENU_CHANNEL.Commission_report,
            hiddenCaseList: true,
            hiddenAction: true
        });
    };
    __decorate([
        Dependencies(CaseRepaymentService)
    ], CommissionReport.prototype, "caseRepaymentService", void 0);
    __decorate([
        Dependencies(PageService)
    ], CommissionReport.prototype, "pageService", void 0);
    __decorate([
        Dependencies(UserService)
    ], CommissionReport.prototype, "userService", void 0);
    __decorate([
        State
    ], CommissionReport.prototype, "principalList", void 0);
    CommissionReport = __decorate([
        Auth(2104),
        Layout('workspace'),
        Component({
            components: {
                SelectDepartment: SelectDepartment,
                NumberRange: NumberRange
            }
        })
    ], CommissionReport);
    return CommissionReport;
}(Vue));
export default CommissionReport;
